import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  HOMEPAGE_EVENTS_PAGE_PATH,
  HOMEPAGE_EVENTS_PAGE_ADD_PATH,
  HOMEPAGE_EVENTS_PAGE_UPDATE_PATH,
} from "utils/constants/paths";

const HomepageEvents = Loadable(React.lazy(() => import("./View")));
const HomepageEventsAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate")),
);

export const HomepageEventsRoute: IRouteItem = {
  path: HOMEPAGE_EVENTS_PAGE_PATH,
  element: React.createElement(HomepageEvents),
  name: "Homepage Events Listing",
  children: [
    {
      name: "Add / Update",
      path: HOMEPAGE_EVENTS_PAGE_ADD_PATH,
      element: React.createElement(HomepageEventsAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: HOMEPAGE_EVENTS_PAGE_UPDATE_PATH,
      element: React.createElement(HomepageEventsAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
